export default "__VITE_ASSET__D0R1hPCT__"